import { updateUser } from 'common/api/companies';
import showToast from 'common/utils/showToast';

import { SAVE, SAVE_SUCCESS, SAVE_FAILURE } from '../actionTypes';
import { companyUsersActions } from '../reducer';
import * as selectors from '../selectors';

import fetchUsers from './fetchUsers';
import resetForm from './resetForm';
import toggleModalUser from './toggleModalUser';

export default (values) => (dispatch, getState) => {
    const filters = selectors.getFilters(getState());
    let newValues = {
        first_name: values.first_name,
        last_name: values.last_name,
        second_surname: values.second_surname,
        phone: values.phone,
        birth_date: values.birth_date,
        company_group: values.company_group,
        position: values.position,
        email: values.email,
        is_enabled: values.is_enabled,
        has_tmp_password: values.has_tmp_password,
        tmp_password: values.tmp_password,
    };

    dispatch(companyUsersActions[SAVE]());

    updateUser(values.company_id, values.id, newValues)
        .then((response) => {
            dispatch(companyUsersActions[SAVE_SUCCESS](response.data));
            dispatch(
                fetchUsers(
                    filters.id,
                    filters.page,
                    filters.orderBy,
                    filters.sortBy,
                    filters.searchStr,
                ),
            );
            dispatch(toggleModalUser(false));
            dispatch(resetForm());
            showToast();
        })
        .catch((error) =>
            dispatch(
                companyUsersActions[SAVE_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
